import type { DeepCleanOptions, UpdaterJob, MachineWorkflow } from '../types/modpackUpdater';

export const DEEPCLEAN_STEPS = ['Select', 'Maintenance', 'Stop', 'Scan', 'Review', 'Clean', 'Start', 'Accept'];
export const DEFAULT_DEEPCLEAN_OPTIONS: DeepCleanOptions = {
  active_days: 90, ring: 1, claim_ring: 1, spawn_ring: 2, end_ring: 2,
  min_playtime_minutes: 0, portal_link: true, relocate: true,
  keep_modified_within: null, keep_dims: [], wipe_dims: [], quarantine: false,
};

export const jobWorkflow = (job: Pick<UpdaterJob, 'workflow'>): MachineWorkflow => job.workflow ?? 'modpack';
export const workflowJobs = (jobs: UpdaterJob[] | undefined, workflow: MachineWorkflow) =>
  (jobs ?? []).filter(job => jobWorkflow(job) === workflow);

export function deepCleanOptionsError(options: DeepCleanOptions): string | null {
  for (const [key, label, min, max] of [
    ['active_days', 'Activity window', 14, 3650], ['ring', 'Player protection ring', 0, 8],
    ['claim_ring', 'Claim protection ring', 0, 8], ['spawn_ring', 'Spawn protection ring', 0, 16],
    ['end_ring', 'End protection ring', 0, 16], ['min_playtime_minutes', 'Minimum playtime', 0, 10080],
  ] as const) {
    if (!Number.isInteger(options[key]) || options[key] < min || options[key] > max) return `${label} must be a whole number from ${min} to ${max}.`;
  }
  if (options.keep_modified_within !== null && (!Number.isInteger(options.keep_modified_within)
    || options.keep_modified_within < 1 || options.keep_modified_within > 3650)) return 'Keep recently modified regions must be blank or a whole number from 1 to 3650 days.';
  for (const dims of [options.keep_dims, options.wipe_dims]) {
    if (dims.length > 64 || dims.some(dim => !dim || dim.length > 200 || /[\x00-\x1f\x7f]/.test(dim))) return 'Use up to 64 dimension IDs or folder names, one per line and up to 200 characters each.';
    if (new Set(dims).size !== dims.length) return 'List each dimension only once.';
  }
  if (options.keep_dims.some(dim => options.wipe_dims.includes(dim))) return 'A dimension cannot be both kept and wiped.';
  return null;
}

export const dimensionLines = (value: string) => value.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
